import { defineMessages } from 'react-intl'

export default defineMessages({
  total: { defaultMessage: 'Total' },
  availableCashoutAmount: { defaultMessage: 'Available cashout amount' },
  twd: { defaultMessage: 'TWD' },
  hkd: { defaultMessage: 'HKD' },
  usd: { defaultMessage: 'USD' },
})
